import { render, staticRenderFns } from "./Returnbook.vue?vue&type=template&id=2a18d492&scoped=true&"
import script from "./Returnbook.vue?vue&type=script&lang=js&"
export * from "./Returnbook.vue?vue&type=script&lang=js&"
import style0 from "./Returnbook.vue?vue&type=style&index=0&id=2a18d492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a18d492",
  null
  
)

export default component.exports